<template>
  <div>
    <v-container
      class="confirmation mt-6 px-sm-6 py-sm-5 px-md-12 py-md-10"
      :style="'border-color: ' + this.user.config.parameters.parameters.colorprimary + ';'"
    >
      <v-row no-gutters>
        <div class="col-12 mb-6 confirmation-button-row">
          <ProgressButton
            :label="{ text: this.text.buttonBack, alias: 'Confirmation-button--back', page: 'confirmation', action: 'previous' }"
            :step="{ number: 2 }"
          />
          <ProgressButton
            :label="{ text: this.text.buttonNext, alias: 'Confirmation-button--next', page: 'confirmation', action: 'next' }"
            :step="{ number: 4 }"
            :style="{ float: 'right' }"
          />
          <h2 style="margin-top: 20px">{{ user.car.maketext }} {{ user.car.modeltext }}</h2>
          <div class="d-flex align-baseline">
            <p class="confirmation__header mb-1">{{ $t('pageAccept.regNumber') }}:</p>
            <p class="confirmation__description pl-1 mb-1">{{ user.registrationplate }}</p>
          </div>
          <div class="d-flex align-baseline mb-5">
            <p class="confirmation__header">{{ $t('pageAccept.drivenKilometers') }}:</p>
            <p class="confirmation__description pl-1">{{ user.kilometers }}</p>
          </div>
          <v-divider></v-divider>
        </div>
        <div class="col-md-6 mt-3">
          <p class="confirmation__header mb-2">{{ $t('pageAccept.location') }}</p>
          <p class="confirmation__description">
            {{ user.department.name }}
            <br />
            {{ user.department.address }}
            <br />
            {{ user.department.zipcode }} {{ user.department.city }}
          </p>
          <br />
          <p class="confirmation__header mb-2">{{user.datetime.option.title}}</p>
          <p class="confirmation__description">{{user.datetime.option.text}}</p>
        </div>
        <div class="col-md-6 mt-3">
          <p class="confirmation__header mb-2">{{ $t('pageAccept.dateTime') }}</p>
          <p class="confirmation__description">
            {{ jobDate }}
            <br />
            {{ $t('pageAccept.handover') }}
            <span v-if="user.config.language !== 'no'">{{ $t('general.words.clock') }}</span>
            {{ user.datetime.arrival.text }}
            <br v-if="user.datetime.pickup !== ''" />
            <span v-if="user.datetime.pickup !== ''">
              {{ $t('pageAccept.pickup') }}
              {{ $t('general.words.clock') }}
              {{ user.datetime.pickup.text }}
            </span>
            <br v-if="user.datetime.rental" />
            <span v-if="user.datetime.rental">{{ $t('pageAccept.rental') }}</span>
          </p>
          <br />
          <br v-if="user.datetime.pickup === ''" />
          <p class="confirmation__header mb-2">{{ $t('pageAccept.yourServices') }}</p>
          <br />
          <table>
            <tr class="confirmation__description-item" v-for="item in this.user.services" :key="item.jobcode">
              <td>{{ item.jobdescription }}</td>
              <td class="confirmation__description-itemvalue" v-if="user.config.parameters.parameters.servicesprice && item.jobprice > 0">
                {{ item.jobprice }} {{ $t('general.words.currency') }} *
              </td>
            </tr>
          </table>
          <div
            class="d-flex align-baseline justify-space-between"
            v-if="user.config.parameters.parameters.culture !== 'no-NO' && user.config.parameters.parameters.servicesprice && this.totalPrice !== ''"
          >
            <p class="confirmation__header mb-2">{{ $t('pageAccept.total')}} {{ $t('general.words.from') }}:</p>
            <p class="text-right">{{ this.totalPrice }}</p>
          </div>
        </div>
      </v-row>
      <v-row no-gutters class="bottom-confirmation-button-row">
        <div class="col-12">
          <div class="text-right body-1">
            <p class="confirmation__description" v-if="user.config.parameters.parameters.servicestime">
              {{ $t('pageAccept.expectedServiceTime') }}: {{ this.totalTime }} *
            </p>
          </div>
        </div>
        <p class="confirmation__description">* {{ user.config.parameters.parameters.customdisclaimertext }}</p>
        <ProgressButton
          :label="{ text: this.text.buttonBack, alias: 'Confirmation-button--back', page: 'confirmation', action: 'previous' }"
          :step="{ number: 2 }"
        />
        <ProgressButton
          :label="{ text: this.text.buttonNext, alias: 'Confirmation-button--next', page: 'confirmation', action: 'next' }"
          :step="{ number: 4 }"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import localizationTexts from '@/localization/texts.json';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import ProgressButton from '@/components/ProgressButton.vue';
const { mapGetters } = createNamespacedHelpers('user');
function numberWithCommas(x) {
  x = x.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x)) x = x.replace(pattern, '$1.$2');
  return x;
}

export default Vue.extend({
  name: 'InfoConfirmation',
  components: {
    ProgressButton
  },
  data() {
    return {
      text: {
        buttonBack: '',
        buttonNext: ''
      },
      texts: {
        comment: ''
      },
      totalTime: '',
      totalPrice: '',
      jobDate: ''
    };
  },
  mounted() {
    this.text.buttonBack = localizationTexts[this.user.config.language].button.back;
    this.text.buttonNext = localizationTexts[this.user.config.language].button.accept;
    this.setTotalTime();
    this.setTotalPrice();
    this.setJobDate();
  },
  methods: {
    setJobDate() {
      this.jobDate =
        new Date(this.user.datetime.date).getDate() +
        '/' +
        (new Date(this.user.datetime.date).getMonth() + 1) +
        ' ' +
        new Date(this.user.datetime.date).getFullYear();
    },
    setTotalPrice() {
      let price = 0;
      let allPrices = true;
      this.user.services.forEach((item) => {
        price = price + item.jobprice;
        if (item.jobprice === 0) {
          allPrices = false;
        }
      });
      if (allPrices) {
        this.totalPrice = numberWithCommas(price) + ',-*';
      }
    },
    setTotalTime() {
      const textHours =
        this.user.servicesTime.hours > 1
          ? localizationTexts[this.user.config.language].general.time.hours
          : localizationTexts[this.user.config.language].general.time.hour;
      const textMinutes =
        this.user.servicesTime.minutes > 1
          ? localizationTexts[this.user.config.language].general.time.minutes
          : localizationTexts[this.user.config.language].general.time.minute;

      this.totalTime = '';
      if (this.user.servicesTime.hours > 0) {
        this.totalTime += this.user.servicesTime.hours + ' ' + textHours + ' ';
      }
      if (this.user.servicesTime.minutes > 0) {
        this.totalTime += this.user.servicesTime.minutes + ' ' + textMinutes + ' ';
      }
    }
  },
  computed: mapGetters(['user'])
});
</script>

<style scoped lang="scss">
@import './src/assets/scss/_variables.scss';
.confirmation {
  border: solid 2px $primaryColor;
  h2 {
    font-weight: 400;
  }
  &__header {
    font-weight: 600;
    font-size: 1rem;
  }

  &__description {
    font-weight: 200;
    font-size: 0.875rem;
    line-height: 1.5rem;

    &-item {
      list-style-type: none;
    }
  }

  table {
    width: 100%;
  }

  &__textarea {
    border-radius: 4px;
  }

  .confirmation-button-row {
    margin-bottom: 20px;
    @media (min-width: 600px) {
      & {
        display: none;
      }
    }
  }

  .bottom-confirmation-button-row {
    justify-content: space-between;
  }
}
.confirmation__description-itemvalue {
  text-align: right;
}
</style>

<i18n src="../localization/texts.json"></i18n>
